export default class MiInversionModel {
  image: string;
  title: string;
}
